import React from "react";
import { useAuth } from "@/context/AuthContext";

export function ImpersonationBanner() {
  const { user, logout } = useAuth();
  if (!user?.impersonator_id) return null;

  return (
    <div
      data-testid="impersonation-banner"
      className="bg-[#1C1C1C] text-white text-xs px-4 py-2 flex items-center justify-center gap-4"
    >
      <span className="tracking-wide">
        Impersonating <strong className="text-white">{user.email}</strong>
      </span>
      <button
        onClick={async () => {
          await logout();
          window.location.href = "/admin";
        }}
        data-testid="exit-impersonation-btn"
        className="underline underline-offset-2 hover:text-[var(--brand)]"
      >
        Exit impersonation
      </button>
    </div>
  );
}
